/* */ 
"use strict";
var core_1 = require('@angular/core');
var collection_1 = require('../facade/collection');
var lang_1 = require('../facade/lang');
var dom_adapter_1 = require('../dom/dom_adapter');
var PublicTestability = (function() {
  function PublicTestability(testability) {
    this._testability = testability;
  }
  PublicTestability.prototype.isStable = function() {
    return this._testability.isStable();
  };
  PublicTestability.prototype.whenStable = function(callback) {
    this._testability.whenStable(callback);
  };
  PublicTestability.prototype.findBindings = function(using, provider, exactMatch) {
    return this.findProviders(using, provider, exactMatch);
  };
  PublicTestability.prototype.findProviders = function(using, provider, exactMatch) {
    return this._testability.findBindings(using, provider, exactMatch);
  };
  return PublicTestability;
}());
var BrowserGetTestability = (function() {
  function BrowserGetTestability() {}
  BrowserGetTestability.init = function() {
    core_1.setTestabilityGetter(new BrowserGetTestability());
  };
  BrowserGetTestability.prototype.addToWindow = function(registry) {
    lang_1.global.getAngularTestability = function(elem, findInAncestors) {
      if (findInAncestors === void 0) {
        findInAncestors = true;
      }
      var testability = registry.findTestabilityInTree(elem, findInAncestors);
      if (testability == null) {
        throw new Error('Could not find testability for element.');
      }
      return new PublicTestability(testability);
    };
    lang_1.global.getAllAngularTestabilities = function() {
      var testabilities = registry.getAllTestabilities();
      return testabilities.map(function(testability) {
        return new PublicTestability(testability);
      });
    };
    lang_1.global.getAllAngularRootElements = function() {
      return registry.getAllRootElements();
    };
    var whenAllStable = function(callback) {
      var testabilities = lang_1.global.getAllAngularTestabilities();
      var count = testabilities.length;
      var didWork = false;
      var decrement = function(didWork_) {
        didWork = didWork || didWork_;
        count--;
        if (count == 0) {
          callback(didWork);
        }
      };
      testabilities.forEach(function(testability) {
        testability.whenStable(decrement);
      });
    };
    if (!lang_1.global.frameworkStabilizers) {
      lang_1.global.frameworkStabilizers = collection_1.ListWrapper.createGrowableSize(0);
    }
    lang_1.global.frameworkStabilizers.push(whenAllStable);
  };
  BrowserGetTestability.prototype.findTestabilityInTree = function(registry, elem, findInAncestors) {
    if (elem == null) {
      return null;
    }
    var t = registry.getTestability(elem);
    if (lang_1.isPresent(t)) {
      return t;
    } else if (!findInAncestors) {
      return null;
    }
    if (dom_adapter_1.getDOM().isShadowRoot(elem)) {
      return this.findTestabilityInTree(registry, dom_adapter_1.getDOM().getHost(elem), true);
    }
    return this.findTestabilityInTree(registry, dom_adapter_1.getDOM().parentElement(elem), true);
  };
  return BrowserGetTestability;
}());
exports.BrowserGetTestability = BrowserGetTestability;
